import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("path", {
  d: "M18 8h1a4 4 0 0 1 0 8h-1"
}), ___EmotionJSX("path", {
  d: "M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"
}), ___EmotionJSX("line", {
  x1: "6",
  y1: "1",
  x2: "6",
  y2: "4"
}), ___EmotionJSX("line", {
  x1: "10",
  y1: "1",
  x2: "10",
  y2: "4"
}), ___EmotionJSX("line", {
  x1: "14",
  y1: "1",
  x2: "14",
  y2: "4"
}));
export default SVG;